import { gql } from '@apollo/client';

export const REPORT_SELF_SERVICE_ANALYTICS_ISSUE = gql`
  mutation ReportSelfServiceAnalyticsIssue {
    reportSelfServiceAnalyticsIssue
  }
`;
